import { Carousel, useMediaDevice } from '@bob/library'
import { AppProviderContext } from '@websrc/App/AppContext'
import { ProductCard } from '@websrc/App/Components/ProductCard/ProductCard'
import { getSchoolSegmentColor } from '@websrc/App/Helpers/getSchoolSegmentColor'
import { matomo } from '@websrc/App/Tracking/Matomo'
import React, { Fragment, useContext } from 'react'

import { Connector } from './Connector/Connector'
import { SwimlanesProps } from './DesktopSwimlanes'
import * as SC from './MobileSwimlanes.style'

export const MobileSwimlanes: React.FC<SwimlanesProps> = ({
  swimlanes: { firstProducts, secondProducts, schoolSegments },
  caption,
}) => {
  const device = useMediaDevice()
  const { matomoPageTemplate } = useContext(AppProviderContext)

  return (
    <SC.SwimlanesContainer>
      {firstProducts.map(({ product, color }, i) => {
        const text = schoolSegments[i].value
        const secondProduct = secondProducts[i].product

        return (
          <Fragment key={i}>
            <Connector connectorColor={getSchoolSegmentColor(color)} text={text} />
            <Carousel hidePaginationDots={true} itemsPerPage={device === 'phone' ? 1 : 2}>
              <SC.ProductWrapper>
                <ProductCard
                  borderColor={getSchoolSegmentColor(color)}
                  onClick={() =>
                    matomo.trackEvent(
                      'engagement',
                      matomoPageTemplate,
                      [caption],
                      [product.title],
                      'product'
                    )
                  }
                  product={product}
                  showCta={false}
                />
              </SC.ProductWrapper>
              <SC.ProductWrapper>
                <ProductCard
                  borderColor={getSchoolSegmentColor(color)}
                  product={secondProduct}
                  showCta={false}
                />
              </SC.ProductWrapper>
            </Carousel>
          </Fragment>
        )
      })}
    </SC.SwimlanesContainer>
  )
}
